const React = require('react');
const { useEffect, useState } = React;
const { default: Styled } = require('styled-components');
const { Link } = require('react-router-dom');
const { context } = require('app-context');

const internals = {};

module.exports = function CommunityWelcomeCard({ user, schoolId }) {

    const scope = `${schoolId || user?.schoolId}:${user?.id}:${user?.roleId}`;
    const [result, setResult] = useState(null);
    const eligible = [2, 12, 99].includes(user?.roleId);
    const { Card } = internals;
    useEffect(() => {

        let current = true;
        setResult(null);
        if (eligible) {
            context.api.nearpeer.communityLaunch.status().then((data) => {

                if (current) { setResult({ scope, data }); }
            }).catch(() => {});
        }

        return () => { current = false; };
    }, [eligible, scope]);

    const status = result?.scope === scope && result.data?.schoolId === (schoolId || user?.schoolId) ? result.data : null;
    if (eligible && status?.enabled && status.reviewOnly && user?.roleId === 99) {
        return <Card aria-label='FREE community review'>
            <h2>FREE community review</h2>
            <p>Read-only overview for {status.schoolName}. Students and prospects remain separate.</p>
            {status.populations.map((population) => <p key={population.key}>
                <strong>{population.key === 'students' ? 'Students' : 'Prospects'}:</strong> {population.state}
                {' · '}{population.eligibleMembers ?? 'Not measured'} eligible
                {' · '}{population.activeMembers ?? 'Not measured'} recently active
            </p>)}
            <p>Welcome card: {status.features.homepageCard ? 'on' : 'off'} · Referrals: {status.features.referrals ? 'on' : 'off'} · Founder recognition: {status.features.foundingRecognition ? 'on' : 'off'} · Group opening: {status.features.stagedGroups ? 'on' : 'off'}</p>
            {status.features.homepageCard && <>
                <h3>Welcome card preview</h3>
                <h2>Help your community take shape.</h2>
                <p>You’re among the first people here at {status.schoolName} on Nearpeer. Invite a friend, meet new people as they join, and help make this community your own.</p>
            </>}
        </Card>;
    }

    if (!eligible || !status?.enabled || !status.showWelcomeCard) { return null; }

    return <Card aria-label='Your growing community'>
        <h2>Help your community take shape.</h2>
        <p>You’re among the first people here at {status.schoolName} on Nearpeer. Invite a friend, meet new people as they join, and help make this community your own.</p>
        {status.referralsEnabled && <Link to='/app/community-invite-friends'>Invite a friend</Link>}
    </Card>;
};

internals.Card = Styled.section`
    padding: 20px;
    border: 1px solid #d6d9e2;
    border-radius: 16px;
    background: #fff;
    h2 { margin: 0 0 12px; font-size: 20px; }
    p { margin: 0 0 12px; line-height: 1.5; }
    a { color: inherit; font-weight: 700; text-decoration: underline; }
`;
